import { styled } from '@nexelem/deprecated-theme';

export const EditorContainer = styled('div')(() => {
  return {
    flex: 'auto',
    position: 'relative',
    resize: 'vertical',
    zIndex: '-1',
  };
});
